module.exports = __webpack_public_path__ + "img/gciosa.c5493282.png";